import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["clipPath",{"id":"iqwiki_svg__a","key":"svg-clipPath"}],["g",{"clip-path":"url(#iqwiki_svg__a)","key":"svg-g"}]]);